import React, { useState } from 'react';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';

const Header = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  return (
      <Navbar className="header-shadow" light expand="md">
        <NavbarBrand href="/">
          <img className="img-logo" src={require('../_assets/image/logofull.png')} />
        </NavbarBrand>
        <NavbarToggler onClick={toggle} />
        <Collapse isOpen={isOpen} navbar>
          <Nav className="ml-auto" navbar>
            <NavItem>
              <NavLink active={props.home} href="/">HOME</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={props.about} href="/about">ABOUT</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={props.investor} href="/investor">INVESTORS</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={props.pricing} href="/pricing">PRICING</NavLink>
            </NavItem>
            <NavItem>
              <NavLink active={props.contact} href="/contact">CONTACT</NavLink>
            </NavItem>
            <NavItem>
              <NavLink href="https://server.irithm.com/#Login">LOGIN</NavLink>
            </NavItem>
          </Nav>
        </Collapse>
      </Navbar>
  )
}

export default Header;
